export const EditButtonSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clipPath="url(#clip0_1_60518)">
      <path
        d="M9.16699 3.33301H3.33366C2.89163 3.33301 2.46771 3.5086 2.15515 3.82116C1.84259 4.13372 1.66699 4.55765 1.66699 4.99967V16.6663C1.66699 17.1084 1.84259 17.5323 2.15515 17.8449C2.46771 18.1574 2.89163 18.333 3.33366 18.333H15.0003C15.4424 18.333 15.8663 18.1574 16.1788 17.8449C16.4914 17.5323 16.667 17.1084 16.667 16.6663V10.833"
        stroke="#64748B"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.417 2.0832C15.7485 1.75168 16.1982 1.56543 16.667 1.56543C17.1358 1.56543 17.5855 1.75168 17.917 2.0832C18.2485 2.41472 18.4348 2.86436 18.4348 3.3332C18.4348 3.80204 18.2485 4.25168 17.917 4.5832L10.0003 12.4999L6.66699 13.3332L7.50033 9.99986L15.417 2.0832Z"
        stroke="#64748B"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_60518">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
